window.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.aps-login').length) {
    var $message
    var $login = document.querySelector('.aps-login')
    var $loginForm = $login.querySelector('.aps-login__form--login')
    var $forgotForm = $login.querySelector('.aps-login__form--forgot')

    function toggleLogin(hide) {
      var isActive = $login.classList.contains('aps-login--active')
      if (isActive || hide) {
        $login.classList.remove('aps-login--active')
        setTimeout(function () {
          $login.style.display = 'none'
          setMessage()
          Array.from($login.querySelectorAll('input')).forEach(function (
            $input
          ) {
            $input.value = ''
          })
          $forgotForm.style.display = 'none'
          $loginForm.style.display = 'flex'
        }, 400)
      } else {
        $login.style.display = 'flex'
        setTimeout(function () {
          $login.classList.add('aps-login--active')
          $login.querySelector('input').focus()
        })
      }
    }

    function setMessage(msg, form) {
      if ($message) {
        $message.style.display = 'none'
        $message.innerHTML = ''
      }
      if (msg && form) {
        $message = $login.querySelector(
          `.aps-login__form--${form} .aps-login__message`
        )
        $message.innerHTML = msg
        $message.style.display = 'block'
      }
    }

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Sec-Fetch-Dest': 'empty',
      'Sec-Fetch-Mode': 'cors',
      'Sec-Fetch-Site': 'same-origin',
    }

    function submitLogin() {
      var reqData = {
        username: $login.querySelector('#login-username').value,
        password: $login.querySelector('#login-password').value,
        remember: false,
      }
      fetch('/aps/services/apsservice.asmx/Login', {
        headers,
        method: 'POST',
        body: JSON.stringify(reqData),
      })
        .then((res) => res.json())
        .then((resData) => {
          if (resData.result) {
            window.location = resData.WelcomeHref || '/'
          } else if (resData.message) {
            setMessage(resData.message, 'login')
          } else {
            throw 'Sorry, there was a problem signing you in. Please check your connection and try again.'
          }
        })
        .catch((err) => {
          setMessage(err, 'login')
          console.error(err)
        })
    }

    function submitForgot() {
      var reqData = {
        email: $login.querySelector('#forgot-username').value,
        last_name: $login.querySelector('#forgot-lastname').value,
      }
      fetch('/aps/services/apsservice.asmx/ForgotPassword', {
        headers,
        method: 'POST',
        body: JSON.stringify(reqData),
      })
        .then((res) => res.json())
        .then((resData) => {
          if (resData.result) {
            setMessage(
              'Password reset instructions have been sent to your email.',
              'forgot'
            )
          } else if (resData.message) {
            setMessage(resData.message, 'forgot')
          } else {
            throw 'Sorry, there was a problem resetting your password. Please check your connection and try again.'
          }
        })
        .catch((err) => {
          setMessage(err, 'forgot')
          console.error(err)
        })
    }

    $login.addEventListener('click', function (ev) {
      ev.stopPropagation()
      toggleLogin()
    })

    Array.from($login.querySelectorAll('.aps-login__close')).forEach(function (
      $close
    ) {
      $close.addEventListener('click', function (ev) {
        ev.preventDefault()
        ev.stopPropagation()
        toggleLogin()
      })
    })

    $loginForm.addEventListener('click', function (ev) {
      ev.stopPropagation()
    })

    $forgotForm.addEventListener('click', function (ev) {
      ev.stopPropagation()
    })

    $loginForm
      .querySelector('.aps-login__forgot')
      .addEventListener('click', function () {
        $loginForm.style.display = 'none'
        $forgotForm.style.display = 'flex'
      })

    $forgotForm
      .querySelector('.aps-login__return')
      .addEventListener('click', function () {
        $forgotForm.style.display = 'none'
        $loginForm.style.display = 'flex'
      })

    $loginForm
      .querySelector('.aps-login__submit')
      .addEventListener('click', function (ev) {
        ev.preventDefault()
        ev.stopPropagation()
        submitLogin()
      })

    $forgotForm
      .querySelector('.aps-login__submit')
      .addEventListener('click', function (ev) {
        ev.preventDefault()
        ev.stopPropagation()
        submitForgot()
      })

    window.aps.toggleLogin = toggleLogin
  }
})
